module.exports = __webpack_public_path__ + "static/media/cod-audit.12c08bef.svg";